<template>
  <div class="wrapper">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <div v-else>
      <div class="header">
        <h6 class="desc">
          {{ `Кв. ${this.objectInfo?.header?.flat_num || ''}${this.objectInfo?.header?.room_name ? `,
          ${this.objectInfo?.header?.room_name}` : ''}`
          }}
        </h6>
        <q-btn v-if="!this.editingMode" class="footer__btn" label="Редактировать" icon="edit" color="orange" size="sm"
          style="" @click="toggleEdit" />
      </div>

      <div class="items" v-if="this.objectInfo?.data && !this.editingMode">
        <div>
          <span style="font-weight: 500;" v-if="!!this.objectInfo?.data?.param_name_height">{{
            this.objectInfo?.data?.param_name_height }}:
          </span>
          <span>{{ this.objectInfo?.data?.param_value_height }}</span>
        </div>
        <div>
          <span style="font-weight: 500;" v-if="!!this.objectInfo?.data?.param_name_width">{{
            this.objectInfo?.data?.param_name_width }}:
          </span>
          <span>{{ this.objectInfo?.data?.param_value_width }}</span>
        </div>
        <div>
          <span style="font-weight: 500;">{{ `Объем${this.objectInfo?.header?.is_has_relative ? ' первого' : ''}
            конструктива: ` }}
          </span>
          <span>{{ this.objectInfo?.data?.main_volume }}</span>
        </div>
        <div v-if="this.objectInfo?.header?.is_has_relative">
          <span style="font-weight: 500;">Второй конструктив: </span>
          <span>{{ this.objectInfo?.data?.floor_param_type_name_relative }}</span>
        </div>
        <div v-if="this.objectInfo?.header?.is_has_relative">
          <span style="font-weight: 500;">Объем второго конструктива: </span>
          <span>{{ this.objectInfo?.data?.second_volume }}</span>
        </div>
        <div v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'">
          <span style="font-weight: 500;">Третий конструктив: </span>
          <span>{{ this.objectInfo?.data?.floor_param_type_name_third }}</span>
        </div>
        <div v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'">
          <span style="font-weight: 500;">Объем третьего конструктива: </span>
          <span>{{ this.objectInfo?.data?.third_volume }}</span>
        </div>
        <div v-if="!!this.objectInfo?.data?.frame_name">
          <span style="font-weight: 500;">Конструкция: </span>
          <span>{{ this.objectInfo?.data?.frame_name }}</span>
        </div>
      </div>

      <div v-if="!this.editingMode && this.showFooter" class="paramObjectFooter">
        <q-tabs v-model="activeTab" dense class="text-grey" active-color="primary" indicator-color="primary"
          align="justify" narrow-indicator>
          <q-tab v-if="this.objectInfo?.header?.is_has_relative" name="constructions" label="Параметры" />
          <q-tab v-if="this.data?.canChooseMaterial" name="materials" label="Материалы" />
        </q-tabs>
        <q-separator />
        <q-tab-panels v-model="activeTab" animated>
          <q-tab-panel name="constructions" v-if="this.objectInfo?.header?.is_has_relative">
            <div className="frameTable">
              <CustomTable :rows-data="this.objectInfo?.frame_info" :columns="this.frameColumns" :custom-body="true">
                <template #customBody="props">
                  <q-tr>
                    <custom-table-cell align="left">
                      {{ props.row.frame_param_type_name }}
                    </custom-table-cell>
                    <custom-table-cell align="right">
                      {{ props.row.param_value }}
                    </custom-table-cell>
                  </q-tr>
                </template>
              </CustomTable>
            </div>
          </q-tab-panel>

          <q-tab-panel name="materials" v-if="this.data?.canChooseMaterial">
            <div class="materials-section">
              <div class="materials-header">
                <q-btn color="primary" icon="add" label="Добавить материалы" size="sm"
                  @click="() => openMaterialsModal()" />
              </div>

              <div v-if="materialsList?.length" class="materials-table">
                <CustomTable :rows-data="materialsGroupedBySet" :columns="materialsColumns" :custom-body="true"
                  :hideTopTitle="true">
                  <template #customBody="props">
                    <q-tr class="set-row">
                      <custom-table-cell align="left" vertical-align="center" colspan="2">
                        {{ props.row.set_name || 'Без набора' }}
                      </custom-table-cell>
                      <custom-table-cell align="center" vertical-align="center">
                        <CustomIcon icon="edit" class="action-icon" @click="() => openMaterialsModal(props.row)"
                          :loading="materialsLoading" />
                      </custom-table-cell>
                    </q-tr>
                    <q-tr v-for="row in props.row.materials" :key="row.floor_param_material_id">
                      <custom-table-cell align="left" vertical-align="center">
                        {{ row.material_name }}
                      </custom-table-cell>
                      <custom-table-cell align="center" vertical-align="center">
                        {{ row.param_value }}
                      </custom-table-cell>
                      <custom-table-cell align="center" vertical-align="center">
                        <div class="actions">
                          <CustomIcon icon="trash" :loading="deletingMaterialId === row.floor_param_material_id"
                            :approve-mode="true" :approve="() => deleteMaterial(row.floor_param_material_id)"
                            class="action-icon" />
                        </div>
                      </custom-table-cell>
                    </q-tr>
                  </template>
                </CustomTable>
              </div>

              <NotFoundText v-else text="Материалы не добавлены" />
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </div>

      <NotFoundText v-if="!this.objectInfo?.data && !this.editingMode" />
      <q-form @submit="this.onSubmit" class="form" v-if="this.editingMode">
        <div class="form__item">
          <CustomInput :label="this.objectInfo?.data?.param_name_height" type="number"
            :value="this.formData.param_value_height"
            @change_input="(value) => onChange('param_value_height', value)" />
        </div>
        <div class="form__item">
          <CustomInput :label="this.objectInfo?.data?.param_name_width" type="number"
            :value="this.formData.param_value_width" @change_input="(value) => onChange('param_value_width', value)" />
        </div>
        <div class="form__item">
          <CustomSelect :options="this.paramTypes || []" label="Конструктив" optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name" :value="this.formData.floor_param_type_id || ''"
            @change="value => this.onChange('floor_param_type_id', value)" />
        </div>
        <div class="form__item" v-if="this.objectInfo?.header?.is_has_relative">
          <CustomSelect :options="this.paramTypes || []" label="Второй конструктив" optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name" :value="this.formData.floor_param_type_id_relative || ''"
            @change="value => this.onChange('floor_param_type_id_relative', value)" />
        </div>
        <div class="form__item" v-if="this.objectInfo?.data?.floor_param_type_code === 'FRAME'">
          <CustomSelect :options="this.paramTypes || []" label="Третий конструктив" optionValueKey="floor_param_type_id"
            optionLabelKey="floor_param_type_name" :value="this.formData.floor_param_type_id_third || ''"
            @change="value => this.onChange('floor_param_type_id_third', value)" />
        </div>
        <div class="form__item">
          <CustomSelect :options="this.frames || []" label="Конструкция" optionValueKey="frame_id"
            optionLabelKey="frame_name" :value="this.formData.frame_id || ''"
            @change="value => this.onChange('frame_id', value)" />
        </div>
        <CustomModalFooter :btn-loading="this.loading" :onCancel="this.toggleEdit" />
      </q-form>
    </div>

    <FloorSchemaMaterialsModal v-if="materialsModalOpen" v-model="materialsModalOpen"
      :floor-param-id="this.objectInfo?.header?.floor_param_id" :floor-map-id="this.data?.floorMapId"
      :edit-material-set-id="this.editingSetId" :edit-materials="editingMaterials" :onSubmit="onMaterialsSaved" />
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import NotFoundText from "@/components/common/NotFoundText.vue";
import PopupConfirm from "@/components/common/PopupConfirm";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomIcon from "@/components/common/CustomIcon.vue";
import FloorSchemaMaterialsModal from "@/views/BuildingSettings/addMaterials";
import { getFloorParamFrames, getFloorParamTypes, getSchemaObjectInfo, updateFloorMapLine, frameColumns, deleteFloorParamMaterial } from "@/views/BuildingSettings/services";
import { useAppStore } from "@/services/store/app";

export default {
  name: "floor-schema-object-info",
  components: {
    NotFoundText,
    PopupConfirm,
    CustomInput,
    CustomModalFooter,
    CustomSelect,
    CustomTable,
    CustomTableCell,
    CustomIcon,
    FloorSchemaMaterialsModal
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      frameColumns,
      loading: false,
      isFetching: false,
      editingMode: false,
      objectInfo: null,
      formData: {},
      paramTypes: [],
      frames: [],
      activeTab: 'constructions',
      materialsModalOpen: false,
      materialsLoading: false,
      materialsList: [],
      editingMaterials: null,
      editingSetId: null,
      deletingMaterialId: null,
      materialsColumns: [
        {
          name: "material_name",
          label: "Материал",
          field: "material_name",
          align: "left",
        },
        {
          name: "param_value",
          label: "Количество",
          field: "param_value",
          align: "center",
        },
        {
          name: "actions",
          label: "Действия",
          field: "actions",
          align: "center",
        },
      ],
    };
  },
  methods: {
    handleRes(res) {
      if (!res) return
      this.objectInfo = res || {}
      this.activeTab = this.objectInfo?.header?.is_has_relative ? 'constructions' : 'materials'
      if (res?.data) {
        const { param_value_height, param_value_width, floor_param_type_id, floor_param_type_id_relative, floor_param_type_id_third, frame_id } = res.data
        this.formData = {
          param_value_height, param_value_width, floor_param_type_id, floor_param_type_id_relative, floor_param_type_id_third, frame_id,
          floor_param_id: res?.header?.floor_param_id
        }
      }
      if (res?.materials) {
        this.materialsList = res.materials
      }
    },
    async getData() {
      this.isFetching = true;
      const res = await getSchemaObjectInfo(this.data?.data?.floor_param_id, this.data?.params?.project_type_id)
      this.isFetching = false;
      this.handleRes(res)
    },
    async onSubmit() {
      this.loading = true
      const res = await updateFloorMapLine(this.formData, { project_type_id: this.data?.params?.project_type_id, floor_param_id: this.formData.floor_param_id })
      this.loading = false
      if (!res) return
      this.toggleEdit()
      this.showSucceedSnackbar()
      this.changeModalTitle(`${res?.data?.floor_param_type_name} (ID: ${res?.header?.floor_param_id})`)
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
    },
    toggleEdit() {
      this.editingMode = !this.editingMode
    },
    onChange(key, value) {
      this.formData[key] = value
    },
    async getParamTypes() {
      const res = await getFloorParamTypes()
      this.paramTypes = res
    },
    async getParamFrames() {
      const res = await getFloorParamFrames(this.data?.resident_id)
      this.frames = res
    },
    editMaterial(set) {
      this.editingMaterials = [...set.materials]
      this.editingSetId = set.material_set_id
      this.materialsModalOpen = true
    },
    openMaterialsModal(set) {
      if (set?.materials?.length) {
        return this.editMaterial(set)
      }
      this.editingSetId = null
      this.editingMaterials = null
      this.materialsModalOpen = true
    },
    async deleteMaterial(floor_param_material_id) {
      this.deletingMaterialId = floor_param_material_id
      const res = await deleteFloorParamMaterial(this.objectInfo?.header?.floor_param_id, floor_param_material_id)
      this.deletingMaterialId = null
      if (!res) return
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
      this.showSucceedSnackbar()
    },
    onMaterialsSaved(res) {
      this.handleRes(res)
      this.data?.onSubmit && this.data.onSubmit()
    },
  },
  computed: {
    showFooter() {
      return this.data?.canChooseMaterial || this.objectInfo?.header?.is_has_relative
    },
    materialsGroupedBySet() {
      if (!Array.isArray(this.materialsList) || !this.materialsList.length) return [];
      const map = this.materialsList.reduce((grouped, material) => {
        const key = material?.material_set_id ?? 'null';
        if (!grouped[key]) grouped[key] = { set_name: material?.set_name, material_set_id: material?.material_set_id ?? null, materials: [] };
        grouped[key].materials.push(material);
        return grouped;
      }, {});
      return Object.values(map);
    }
  },
  mounted() {
    this.getData()
    this.getParamTypes()
    this.getParamFrames()
  },
  setup() {
    const { changeModalTitle } = useAppStore()
    const { showSucceedSnackbar } = useCustomSnackbar()
    return { showSucceedSnackbar, changeModalTitle }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  min-width: 450px;
}

@media (max-width: 576px) {
  .wrapper {
    min-width: 100%;
  }
}

.title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 10px;
}

.items {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.paramObjectFooter {
  margin-top: 25px;
}

.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;
}

.desc {
  font-size: 14px;
  color: #333;
  line-height: 1;
  margin: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  margin-top: 10px;
}

.materials-section {
  padding: 16px 0;
}

.materials-header {
  margin-bottom: 16px;
}

.materials-table {
  margin-top: 16px;
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-icon {
  cursor: pointer;
  padding: 4px;
}

.set-row {
  background: #fff3e0;
  /* light orange for visibility */
  font-weight: 600;
}
</style>
